<template>
  <div>
    <TemplateTextBlock v-for="(block, idx) in text" :key="idx" :block="block" />
  </div>
</template>

<script>
import TemplateTextBlock from './TemplateTextBlock'

export default {
  name: 'TemplateText',
  components: {
    TemplateTextBlock,
  },
  props: {
    text: Array,
  }
}
</script>

<style scoped lang="scss"></style>
